/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Cart, ReasonCodeLine } from '@msdyn365-commerce/retail-proxy';
import { overrideCartLineChargeAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
/**
 * OverrideCartLines Input Action
 */
export class OverrideCartLinesInput implements Msdyn365.IActionInput {
    public cartId: string;
    public cartLineId: string;
    public chargeLineId?: string;
    public amount: number;
    public reasonCodeLines?: ReasonCodeLine[] | null | undefined;

    constructor(cartId: string, cartLineId: string, amount: number, chargeLineId?: string, reasonCodeLines?: ReasonCodeLine[]) {
        this.cartId = cartId;
        this.cartLineId = cartLineId;
        this.amount = amount;
        this.chargeLineId = chargeLineId;
        this.reasonCodeLines = reasonCodeLines;
    }

    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createInput = (
    args: Msdyn365.ICreateActionContext<{
        cartId: string;
        cartLineId: string;
        chargeLineId: string;
        amount: number;
        reasonCodeLines?: ReasonCodeLine[];
    }>
): Msdyn365.IActionInput => {
    return new OverrideCartLinesInput(
        args.config?.cartId || '',
        args.config?.cartLineId || '',
        args.config?.amount || 0,
        args.config?.chargeLineId || '',
        args.config?.reasonCodeLines || []
    );
};

async function overrideCartLineAsync(input: OverrideCartLinesInput, ctx: Msdyn365.IActionContext): Promise<Cart> {
    const response = await overrideCartLineChargeAsync(
        { callerContext: ctx },
        input.cartId,
        input.cartLineId,
        input.chargeLineId || '',
        input.amount,
        input.reasonCodeLines
    );
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Cart>>overrideCartLineAsync,
    id: 'OverrideCartLines',
    input: createInput
});
